import { apiClient } from './api';
import { UserFormData } from '../schemas/userSchema';
import { User } from '../types/user';

export interface GetUsersResponse {
  users: User[];
  scope: 'organization' | 'all';
  totalCount: number;
}

export const userService = {
  async getUsers(options?: { scope?: 'all' }): Promise<GetUsersResponse> {
    const result = await apiClient.getUsers(options);
    return {
      users: result.users as unknown as User[],
      scope: result.scope,
      totalCount: result.totalCount
    };
  },

  async getUserById(id: string): Promise<User> {
    const result = await apiClient.getUserById(id);
    return result.user as unknown as User;
  },

  async createUser(userData: UserFormData): Promise<User> {
    const result = await apiClient.createUser(userData);
    return result.user as unknown as User;
  },

  async updateUser(id: string, userData: UserFormData): Promise<User> {
    const result = await apiClient.updateUser(id, userData);
    return result.user as unknown as User;
  },

  async deleteUser(id: string): Promise<void> {
    await apiClient.deleteUser(id);
  },
}; 